import { render, staticRenderFns } from "./Ekspedisi.vue?vue&type=template&id=adabda9e&scoped=true&"
import script from "./Ekspedisi.vue?vue&type=script&lang=js&"
export * from "./Ekspedisi.vue?vue&type=script&lang=js&"
import style0 from "./Ekspedisi.scss?vue&type=style&index=0&id=adabda9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adabda9e",
  null
  
)

export default component.exports